import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UUID } from '@app/_api/identifyable';
import { BaseApi } from '@app/core/services/api/base.api';
import { ToastService } from '@app/core/services/toast.service';
import { DialogService } from '@app/core/services/dialog.service';
import { SkillDto } from '@app/core/model/skill-dto';

@Service()
export class SkillCoreApi extends BaseApi {
  constructor() {
    const http = inject(HttpClient);
    const toastService = inject(ToastService);
    const dialog = inject(DialogService);

    super(http, '/skill-core', toastService, dialog);
  }

  fetchAllSkills() {
    return super.GET<SkillDto[]>('/all');
  }

  fetchSkillFamilyIds(skillId: UUID) {
    return super.GET<string[]>(`/search/${skillId}`);
  }
}
